<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>

        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Usuarios</h2>
                </div>
                <div class="col-lg-2">
                    <br>
                    <button (click)="openModal(myModalUsuario)" type="button" class="boton fondoAmarillo blanco bold" > Agregar <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg> </button>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-11">
                    <br>
                    <div class="row">
                        <div class="col-lg-4"></div>
                        <div class="col-lg-4">
                            <button (click)="getUsuariosActivos()" id="activos" class="fondoAmarillo blanco bold" style="border:0px">Activos</button>
                            <button (click)="getUsuariosInactivos()" id="inactivos" style="border:0px">Inactivos</button>
                        </div>
                        <div class="col-lg-4"></div>
                    </div>
                    
                    <br>
                    <table  class="table table-striped row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                        <thead class="thead-dark">
                            <tr>
                                <td>Nombre</td>
                                <td>Celular</td>
                                <td>Correo electrónico</td>
                                <td>Tipo</td>
                                <td>Editar</td>
                                <td>
                                    <div *ngIf="activar == 1">Desactivar</div>
                                    <div *ngIf="activar == 2">Activar</div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let usuario of usuarios">
                                <td>{{usuario.nombre}}</td>
                                <td>{{usuario.celular}}</td>
                                <td>{{usuario.email}}</td>
                                <td>
                                    <span *ngIf="usuario.tipo == 1">Administrador</span>
                                    <span *ngIf="usuario.tipo == 2">Vendedor</span>
                                </td>
                                <td>
                                    <a (click)="editarUsuario(usuario.id)">
                                    <svg  style="color:gray" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                    </svg>
                                    </a>
                                </td>
                                <td>
                                    <div *ngIf="activar == 1">
                                        <a (click)="desactivarUsuario(usuario.id)">
                                            <svg xmlns="http://www.w3.org/2000/svg" style="color: red;" width="16" height="16" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                            </svg>
                                        </a>
                                    </div>

                                    <div *ngIf="activar == 2">
                                        <a (click)="activarUsuario(usuario.id)">
                                            <svg xmlns="http://www.w3.org/2000/svg" style="color:green;" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                              </svg>
                                        </a>
                                    </div>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
</div>


<ng-template #myModalUsuario let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Agregar Usuario</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario.nombre"><br>
        <input type="text" class="form-control" placeholder="Apellidos" [(ngModel)]="formulario.apellidos"><br>
        <input type="text" class="form-control" placeholder="Celular" [(ngModel)]="formulario.celular"><br>
        <input type="text" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formulario.email"><br>
        <input type="password" class="form-control" placeholder="Contraseña" [(ngModel)]="formulario.password"><br>
        <select class="form-control" [(ngModel)]="formulario.tipo">
            <option value="">Seleeccione tipo de Usuario</option>
            <option value="1">Administrador</option>
            <option value="2">Vendedor</option>
        </select>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" type="button" [disabled]="guardandoUsuario" (click)="agregarUsuario()">Agregar Usuario</button>
    </div>
</ng-template>



  
<div id="clickEditar" (click)="openModal(myModalEditar)"></div>

<ng-template #myModalEditar let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Editar Usuario</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formularioEdit.nombre"><br>
        <input type="text" class="form-control" placeholder="Apellidos" [(ngModel)]="formularioEdit.apellidos"><br>
        <input type="text" class="form-control" placeholder="Celular" [(ngModel)]="formularioEdit.celular"><br>
        <input type="text" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formularioEdit.email"><br>
        <input type="password" class="form-control" placeholder="Contraseña" [(ngModel)]="formularioEdit.password"><br>
        <select class="form-control" [(ngModel)]="formularioEdit.tipo">
            <option value="">Seleeccione tipo de Usuario</option>
            <option value="1">Administrador</option>
            <option value="2">Vendedor</option>
        </select>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="updateCliente(usuarioid)">Editar Usuario</button>
    </div>
</ng-template>
